import BlockPagination from './BlockPagination';

export default BlockPagination;
